<template>
  <v-dialog v-model="showModal" width="480" @click:outside="closeDialog">
    <v-card max-width="480">
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="text-h5 text-medium-emphasis ps-2 title-text">{{ editDividend ? 'edit dividend / distribution' : 'add dividend / distribution' }}</div>
        <v-btn icon="mdi-close" variant="text" @click="closeDialog"></v-btn>
      </v-card-title>
      <v-divider class="mb-4"></v-divider>
      <v-card-text>
        <v-sheet class="mx-auto" width="380">
          <v-form @submit.prevent ref="form">
            <v-text-field :value="ticker" label="ticker" variant="underlined" class="form_field" disabled></v-text-field>
            <v-text-field v-model="ex_date" :rules="[required]" label="ex date" variant="underlined" type="date" class="form_field"></v-text-field>
            <v-text-field v-model="payment_date" label="payment date (optional)" variant="underlined" type="date" class="form_field"></v-text-field>
            <v-text-field v-model.number="amount_per_unit" :rules="[required, numeric]" label="amount per unit" variant="underlined" type="number" class="form_field"></v-text-field>
            <v-select v-model="currency" :rules="[required]" :items="currencies" label="currency" variant="underlined" class="form_field"></v-select>
            <v-text-field v-model.number="franking_credits_per_unit" label="franking credits per unit (optional)" variant="underlined" type="number" class="form_field"></v-text-field>
          </v-form>
        </v-sheet>
      </v-card-text>
      <template v-slot:actions>
        <div class="w-100">
          <v-btn v-on:click="submitForm" class="mt-2 submit_button" type="submit" block>save</v-btn>
          <v-btn v-if="editDividend" color="error" variant="text" class="mt-1" block @click="deleteEntry">delete</v-btn>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';

export default {
  props: {
    show: Boolean,
    ticker: String,
    defaultCurrency: { type: String, default: 'AUD' },
    editDividend: { type: Object, default: null },
  },
  data() {
    return {
      ex_date: '',
      payment_date: '',
      amount_per_unit: '',
      currency: this.defaultCurrency,
      franking_credits_per_unit: '',
      currencies: ['AUD', 'USD', 'GBP', 'SGD', 'CAD', 'SEK'],
    };
  },
  computed: {
    ...mapState({ token: 'token' }),
    showModal: {
      get() { return this.show; }
    },
  },
  watch: {
    show(val) {
      if (val && this.editDividend) {
        this.ex_date = String(this.editDividend.ex_date).slice(0, 10);
        this.payment_date = this.editDividend.payment_date ? String(this.editDividend.payment_date).slice(0, 10) : '';
        this.amount_per_unit = this.editDividend.amount_per_unit;
        this.currency = this.editDividend.currency;
        this.franking_credits_per_unit = this.editDividend.franking_credits_per_unit ?? '';
      }
    },
  },
  methods: {
    ...mapMutations(['showSnackbar']),
    required: v => !!v || 'required',
    numeric: v => !isNaN(v) || 'must be a number',
    closeDialog() {
      this.reset();
      this.$emit('close');
    },
    reset() {
      this.ex_date = '';
      this.payment_date = '';
      this.amount_per_unit = '';
      this.currency = this.defaultCurrency;
      this.franking_credits_per_unit = '';
    },
    async deleteEntry() {
      try {
        await axios.delete('/securities/dividends/' + this.editDividend.id, {
          headers: { Authorization: `Bearer ${this.token}` }
        });
        this.$emit('deleted');
        this.closeDialog();
      } catch {
        this.showSnackbar({ message: 'Failed to delete distribution' });
      }
    },
    async submitForm(e) {
      e.preventDefault();
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      try {
        const payload = {
          ticker: this.ticker,
          ex_date: this.ex_date,
          payment_date: this.payment_date || null,
          amount_per_unit: this.amount_per_unit,
          currency: this.currency,
          franking_credits_per_unit: this.franking_credits_per_unit || null,
        };
        if (this.editDividend) {
          await axios.put('/securities/dividends/' + this.editDividend.id, payload, {
            headers: { Authorization: `Bearer ${this.token}` }
          });
        } else {
          await axios.post('/securities/dividends', payload, {
            headers: { Authorization: `Bearer ${this.token}` }
          });
        }
        this.$emit('saved');
        this.closeDialog();
      } catch (error) {
        this.showSnackbar({ message: 'Failed to save dividend entry' });
      }
    },
  },
};
</script>
